
<template>
    <section class="checkout-section">
        <div class="section-header">
            <h2>{{ resources.flyIn.title }}</h2>
        </div>
        <div class="section-row">
            <button class="btn btn-full-wdth btn-add" @click="showNewAddressForm">
                <span>{{ resources.flyIn.addNewCTA }}</span>
            </button>
        </div>
        <div class="section-row">
            <span class="section-row-header">{{ resources.defaultAddressLabel }}</span>
            <div v-if="defaultAddress.length" class="vertical-tile-list">
                <address-option-tile
                    :key="defaultAddress[0].id + type"
                    :option="defaultAddress[0]"
                    :isInFlyin="true"
                    :type="type"

                />
            </div>
            <div class="inline-alert notify" v-else>
                <span>{{ resources.noDefaultAddressInfo }}</span>
            </div>
        </div>

        <div class="section-row">
            <span class="section-row-header">{{ resources.otherAddressesLabel }}</span>
            <div v-if="otherAddresses.length" class="vertical-tile-list">
                <template v-for="option in otherAddresses">
                    <address-option-tile v-if="!option.temporary"
                        :key="option.id + type"
                        :option="option"
                        :isInFlyin="true"
                        :type="type"
                    />
                </template>
            </div>
            <div class="inline-alert notify" v-else>
                <span>{{ resources.noOtherAddressesInfo }}</span>
            </div>
        </div>
    </section>
</template>

<script src="./address-option-tile-list.js"/>
